/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
const checklistRowStyle = {
  checklistLabel: {
    fontWeight: 400,
    paddingTop: "10px",
  },
  checklistDescription: {
    padding: "0.5rem 0",
  },
  checked: {
    textDecoration: "line-through",
  },
};

export default checklistRowStyle;
